import * as React from "react";
const AssistantCoach = (props) => (
    <svg
        height="512pt"
        width="512pt"
        viewBox="0 0 57 57"
        stroke="black"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M28.5 32.0625C33.4188 32.0625 37.4062 28.075 37.4062 23.1562C37.4062 18.2375 33.4188 14.25 28.5 14.25C23.5812 14.25 19.5938 18.2375 19.5938 23.1562C19.5938 28.075 23.5812 32.0625 28.5 32.0625Z"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M40.9688 49.875C40.9688 46.5681 39.6551 43.3966 37.3167 41.0583C34.9784 38.7199 31.8069 37.4063 28.5 37.4063C25.1931 37.4063 22.0216 38.7199 19.6833 41.0583C17.3449 43.3966 16.0313 46.5681 16.0312 49.875H40.9688Z"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M42.75 24.9375C44.2681 24.9375 45.7611 24.5494 47.087 23.8102C48.413 23.0709 49.528 22.0049 50.3261 20.7135C51.1242 19.4221 51.579 17.9482 51.6473 16.4316C51.7155 14.915 51.3949 13.4061 50.716 12.0483C50.0371 10.6904 49.0223 9.52863 47.7681 8.67326C46.5139 7.81789 45.0618 7.29732 43.5498 7.16099C42.0378 7.02465 40.5161 7.27707 39.1291 7.89428C37.7421 8.51149 36.5359 9.473 35.625 10.6875"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M44.5312 42.75H55.2188C55.2188 39.4431 53.9051 36.2716 51.5667 33.9333C49.2284 31.5949 46.0569 30.2813 42.75 30.2813"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.375 10.6875C20.4641 9.473 19.2579 8.51149 17.8709 7.89428C16.4839 7.27707 14.9622 7.02465 13.4502 7.16099C11.9382 7.29732 10.4861 7.81789 9.23191 8.67326C7.97769 9.52863 6.96294 10.6904 6.28401 12.0483C5.60508 13.4061 5.28452 14.915 5.35275 16.4316C5.42099 17.9482 5.87576 19.4221 6.67389 20.7135C7.47202 22.0049 8.58701 23.0709 9.91297 23.8102C11.2389 24.5494 12.7319 24.9375 14.25 24.9375"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.25 30.2813C10.9431 30.2813 7.77161 31.5949 5.43326 33.9333C3.09492 36.2716 1.78125 39.4431 1.78125 42.75H12.4688"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default AssistantCoach;
